export default {
  "Fleet_Tool_Links_are_ennN": "链接已失效",
  "Fleet_NewPaymentFlow__NhvB": "从{{begin_datetime}}开始收取。金额：{{Price}}，收取频率：{{Frequency}}",
  "Fleet_deactivation_sjNc_YjtD": "取消",
  "Fleet_Resdesign_View_Income_PiyV": "查看收入明细",
  "Fleet_Resdesign_Thursday_JOxF": "周四",
  "Fleet_perception__ndnz": "收入引导",
  "Fleet_NewPaymentFlow_xuka_dUSy": "修改后，将会自动从司机的钱包中收取租金等费用，当司机收入不足以支付时，你需要线下找司机收取剩余部分",
  "upt-city---rwrap_fail": {
    "wtext": "修改失败",
    "wstext1": "您的车型不符合目标城市要求",
    "wstext2": "好像出错了~",
    "wstext3": "修改成功"
  },
  "upt-city---search": {
    "city-location-none": "定位失败",
    "back": "返回",
    "btn-cancel": "取消",
    "city-location-title": "当前定位城市",
    "data_sub": "输入城市名称",
    "city-popular-title": "热门城市",
    "search-content-title": "搜索城市",
    "didi-dialog-p": "每<em class='org'>6</em>个月可修改注册城市<em class='org'>2</em>次，确认修改为({area})吗？",
    "btn-ok": "确定"
  },
  "Fleet_Drivers_Confirm_deletion_aXtK": "确认删除规则？",
  "Fleet_Drivers_Select_Name_OoCI": "选择名称",
  "Fleet_control_ZNQC_ZwIi": "{{Fleet_name}}邀请你加入车队",
  "Fleet_check_aUhi_hmNL": "{{brand_name}}需要获取你的相册权限，以提供头像设置等服务。",
  "GDriver_Enhancement_Repayment_INQd": "还款",
  "Fleet_NewPaymentFlow_svTo_tbpj": "如需要修改，请到个人中心的设置页进行操作",
  "Fleet_check_ejnS_VZqp": "请这张照片将会是你的头像，我们建议你",
  "Fleet_NewPaymentFlow__xbNM": "添加费用",
  "Fleet_check_OaNq_asGe": "头像已上传",
  "Fleet_MatchingTool_Loading_ingu": "加载中",
  "Fleet_Drivers_Name_can_JcFB": "名称不能为空",
  "Fleet_0303_Fleet_WorkRegime_Enter_name_hIvg": "请选择费项名称",
  "Fleet_Resdesign_No_data_CqQU": "没有数据",
  "Fleet_control_mIEb_goHs": "同意并接受邀请",
  "Fleet_Mgt__gsvK": "出租",
  "Fleet_Resdesign_Sunday_jiVr": "周日",
  "Fleet_0303_Fleet_WorkRegime_everyday_BKeT": "每天",
  "Fleet_NewPaymentFlow__UJcK": "我的收入",
  "Fleet_NewPaymentFlow__djTl": "总金额",
  "Fleet_check_TNKJ_sfGt": "不要佩戴帽子、墨镜等饰品",
  "Fleet_Phase1_There_are_TYqj": "这里有海量优质司机",
  "Fleet_NewPaymentFlow_utjU_KAIH": "线下收款",
  "Fleet_Resdesign_January_MKno": "一月",
  "magellan": {
    "martell": {
      "translate": {
        "order_compensate": {
          "driver_channel": {
            "1": "余额"
          }
        }
      }
    }
  },
  "Fleet_Drivers_Rule_number_hDmV": "规则{{number}}",
  "Fleet_NewPaymentFlow__otGL": "所有账单",
  "Fleet_NewPaymentFlow__fiLG": "未收齐",
  "Fleet_check_zWwS_DPsT": "让你的脸展示在屏幕中央",
  "Fleet_Resdesign_Load_last_YWoz": "加载上个月",
  "Fleet_check_HWak_qoaq": "头像上传",
  "Fleet_Drivers_Add_Rules_KTVL": "添加规则",
  "Fleet_NewPaymentFlow_ebKy_pywA": "已收金额",
  "Fleet_optimizaton__ZYCj": "前往绑定车辆",
  "Fleet_start__sbZS": "回到\"新手指引\"",
  "Fleet_Drivers_To_register_MgmZ": "去注册",
  "Fleet_copy_Driver_XTmX": "司机",
  "Fleet_Resdesign_October_pbZU": "十月",
  "Fleet_Resdesign_Enter_email_cylU": "请输入邮箱",
  "Fleet_Phase1_Driver_Market_lUUD": "寻找司机",
  "Fleet_FleetRecommendation_Enter_the_Ykpv": "请输入正确格式的金额",
  "Fleet_Mgt_Delete_the_cmct": "删除车辆？",
  "Fleet_Drivers_The_driver_mSzg": "该司机的工作规则已经保存。",
  "Fleet_Drivers_Delete_NcPF": "删除",
  "dinfo---details": {
    "driver_name_title": "姓名",
    "driver_city_title": "注册城市",
    "car_type": "服务类型"
  },
  "Fleet_check_qxdW_jahK": "脸不在中央",
  "Fleet_start_DumJ_PRKC": "已添加{{amount}}",
  "Fleet_issue_eOHq_BsKZ": "总税费",
  "Fleet_FMS_You_have_pFWa": "您有必填项未填写",
  "Fleet_NewPaymentFlow_QOhW_ZVsb": "确认解绑车辆？",
  "Fleet_NewPaymentFlow__nIsf": "线下已收",
  "Fleet_NewPaymentFlow_wngD_YWNt": "已生效",
  "Fleet_Resdesign_Cash_collection_eETn": "现金收款",
  "Fleet_Mgt_Change_color_ddUl": "修改颜色",
  "Fleet_Resdesign_Account_Amount_kIgR": "账户金额",
  "Fleet_optimizaton__AoyP": "你需要等待证件审核通过后，才能使用该功能",
  "Fleet_issue_mmrE_nuXS": "税明细",
  "Fleet_NewPaymentFlow__wxAJ": "司机表现",
  "Fleet_Drivers_Invitation_to_dIQW": "邀请成功",
  "Fleet_check_ELEN_crck": "你的头像预计在24-48小时内完成审核，我们将通过短信和邮件告知你审核结果，请及时关注。",
  "Fleet_DriverUnbindFleet_Untied_cPMi": "已解绑",
  "Fintech_Payment_management_View_the_VZZP": "查看历史余额",
  "Fleet_Resdesign_Online_SILV": "线上",
  "Fleet_Tool_Untied_successfully_dutX": "解绑成功",
  "Fleet_perception_zHgs_UzNz": "总净收入",
  "Fleet_Tool_Click_to_DNOM": "点击查看",
  "Fleet_perception_vSVy_IyMZ": "现金收款",
  "Fleet_NewPaymentFlow_owVN_GnVJ": "费用收取方式",
  "Fleet_NewPaymentFlow_fsqE_HdZG": "未收金额",
  "Fleet_NewPaymentFlow__yfXt": "编辑费用",
  "Fleet_copy_Deleted_successfully_Mafm": "删除成功",
  "Fleet_Resdesign_Today_s_yBsy": "今天的收入",
  "Fleet_control_1_lIfT": "当你看到该页面时，表明你当前存在欠费情况。造成账户欠费的原因，是你车队中司机的线上收入远小于现金收入，以致司机线上收入不足以支付平台扣费。所有司机的欠费加总会累积到你的账户中，你可以下载报表来核对每个司机的欠费情况。",
  "Fleet_Drivers_Confirm_that_HlwF": "确认要删除规则{{number}}？删除后内容不会被保留",
  "Fleet_Drivers_Bind_cCCG": "已绑定",
  "Fleet_Drivers_Select_frequency_YcRq": "选择频率",
  "Fleet_NewPaymentFlow_cfGZ_kjVX": "当前车辆存在未结清的费用，请先为司机解绑该车辆，再尝试修改费用收取方式",
  "Fleet_Mgt_Loosen_immediately_OZaY": "松开立即刷新",
  "Fleet_Resdesign_Send_csv_ngwh": "通过邮件发送csv报表",
  "Fleet_MultiUserLogin_Mobile_number_RzUl": "注：若你接受邀请，则无法用此手机号注册为司机或车头。",
  "Fleet_0303_Fleet_WorkRegime_daily_ztIr": "每天00:00-12:00之间进行收取",
  "Fleet_control_OK_sQYN": "好的",
  "Fintech_Payment_Agency__klZT": "展开",
  "Fleet_Drivers_Please_set_YncL": "请设置工作规则",
  "Fleet_0303_Fleet_WorkRegime_monthly_XmGW": "每月1号00:00-12:00之间进行收取",
  "Fleet_NewPaymentFlow__uHzl": "在选择的时间段内，已经收到的所有生效的费用项的总金额。包含已收到未提现的金额，已收到已提现的金额和线下收到的金额",
  "Fleet_Phase3_Set_ozBm": "设置",
  "Fleet_control_The_two_wIUS": "平台为你提供银行卡还款或线下还款方式。 银行卡还款一般10分钟内到账，线下还款一般1-2个工作日内到账。点击右上角按钮可以查看还款到账情况。如果超此时间还款未成功，请联系{{mx_contact_info}}。",
  "Fleet_NewPaymentFlow__RjDW": "频次",
  "Fleet_NewPaymentFlow__ltIu": "将会自动从司机的钱包中收取租金等费用，当司机收入不足以支付时，你需要线下找司机收取剩余部分",
  "Fleet_NewPaymentFlow__cGLW": "请注意，接受邀请并加入车队后，车头可以直接新增或者修改账单，你无需再次确认。",
  "Fleet_Resdesign_Calendar_mFPf": "日历",
  "Fleet_Drivers_Amount_YOtw": "金额",
  "Fleet_Resdesign_End_HlIj": "结束",
  "Fleet_check_IYER_eDig": "头像审核通过后，你才可以给车队下的司机绑定车辆。",
  "Fleet_check_PFze_fown": "头像审核中",
  "Fleet_NewPaymentFlow__BFLZ": "下一步",
  "Fleet_NewPaymentFlow_LJUV_JguU": "修改后，所有费用将不再从司机的钱包中自动扣除，你需要线下向司机收取",
  "Fleet_Mgt_Are_you_QgSa": "确定要删除该车辆吗？",
  "Fleet_NewPaymentFlow_OSHq_PQkz": "请选择一辆车",
  "Fleet_Drivers_Enter_verification_AAuw": "请输入验证码",
  "Fleet_Drivers_Enter_the_WTcT": "请输入你会得到的金额",
  "Fleet_NewPaymentFlow_gXEl_ipjf": "待生效",
  "Fleet_check_OZWz_BEqb": "前往上传",
  "Fleet_NewPaymentFlow__yzdB": "车辆信息",
  "Fleet_check_vdqm_jUYr": "不再展示",
  "Fleet_Resdesign__ucKv": "五月",
  "Fleet_Drivers_Rules_of_YEUJ": "工作规则已保存",
  "Fleet_Resdesign_Select_Start_CdGi": "选择开始时间",
  "Fleet_Resdesign_Heaven_Qvoz": "天",
  "Fleet_NewPaymentFlow__VAgV": "展开",
  "Fleet_NewPaymentFlow__OPXo": "确认停用费用？",
  "Fleet_Mgt_No_more_mlms": "没有更多了",
  "Fleet_copy_Bind_the_USYf": "绑定车辆",
  "Fleet_Drivers_Select_the_njUQ": "请选择费项名称",
  "Fleet_optimizaton__sPaq": "你提交的证件仍在审核中/部分未通过审核，可先前往绑定车辆并体验各项产品功能。",
  "Fleet_Mgt_Vehicles_GLnp": "车辆",
  "Fleet_Drivers_Add_a_rMLY": "添加司机",
  "Fleet_Drivers_Vehicle_binding_mfjS": "车辆绑定",
  "Fleet_NewPaymentFlow__PRyq": "每天",
  "Fleet_Resdesign_June_slTp": "六月",
  "Fleet_Drivers_Please_set_nduh": "请设置分账规则",
  "Fleet_start__dyuk": "添加车辆",
  "Fleet_Drivers_Mobile_number_sgwd": "手机号码",
  "Fleet_Resdesign_Wednesday_IHFc": "周三",
  "Fleet_NewPaymentFlow__IogO": "已收总额",
  "Fleet_NewPaymentFlow__zuWo": "司机的手机号：{{phone_num}}",
  "Fleet_NewPaymentFlow__oIIp": "账单列表",
  "Fleet_check_GbcB_hlpe": "请按下方要求上传头像，如本次审核仍不通过，你将无法使用平台部分功能。",
  "Fleet_perception__gmNA": "下载报表",
  "Fleet_check_GKhX_RGRf": "请确保拍照时光线明亮且不使用滤镜",
  "Fleet_Resdesign_Monday_bazB": "周一",
  "Fleet_Resdesign_Send_IBLm": "发送",
  "Fleet_Drivers_Select_the_tKMG": "请选择你获得的频率",
  "Fleet_Tool_You_need_ewbc": "请在7天内操作确认解绑，超过7天链接失效后需重新联系客服处理",
  "Fleet_perception_Ferf_lkOZ": "账户金额",
  "Fleet_Drivers_Save_feyd": "保存",
  "Fleet_Drivers_Daily_00_kmqY": "每天：每天00:00-12:00之间进行收取\n每周：每周一00:00-12:00之间进行收取\n每月：每月1号00:00-12:00之间进行收取",
  "Fleet_0303_Fleet_WorkRegime_weekly_fELn": "每周",
  "Fleet_check_UBBv_ALyB": "不能佩戴饰品",
  "Fleet_0303_Fleet_WorkRegime_amount_obtained_otsv": "请输入您会得到的金额",
  "Fleet_Drivers_Are_you_uWrh": "你确定要删除规则吗？",
  "Fleet_start_VrwW_czSn": "退出登录",
  "Fleet_Resdesign_Total_tUqe": "总账户金额",
  "Fleet_Resdesign_Driver_Summary_zoSe": "司机收入概要",
  "Fleet_payment_Payment_Method_vmsQ": "支付方式",
  "Fleet_NewPaymentFlow__xwbw": "下载报告",
  "Fleet_start__pvQo": "未添加",
  "Fleet_start__ASwv": "你确定要关闭“新手指引”入口吗？",
  "Fleet_optimizaton__OUwE": "证件审核中",
  "Fleet_NewPaymentFlow_ozwI_goeV": "已停用",
  "Fleet_start_aTFD_HHTY": "关于应用",
  "Fleet_NewPaymentFlow__bEhi": "租金等费用，将会自动从你的钱包中扣除",
  "Fleet_NewPaymentFlow__EBXA": "线下收取：你需要自行线下向车头支付租金及其它费用",
  "Fleet_NewPaymentFlow__xLMz": "租金等费用，你需要线下和车头进行结算",
  "Fleet_Drivers_Cancel_YjzD": "取消",
  "Fleet_Drivers_Frequency_can_jPlc": "频率不能为空",
  "Fleet_control2_Vehicles_not_cNeS": "不允许下架车辆",
  "Fleet_NewPaymentFlow__HtrY": "同意并接受邀请",
  "Fleet_Resdesign_Save_it_uMek": "将其保存为你的默认邮箱以便下次使用？",
  "Fleet_NewPaymentFlow__ZxdF": "账单已收明细",
  "Fleet_NewPaymentFlow_ppMF_fAZz": "请先解绑车辆",
  "Fleet_check_KSPJ_glKu": "上传",
  "Fleet_issue_uzuL_mYUR": "我们建议你从司机税前总净收入和税前账户金额中减去此金额。点击查看更多。",
  "Fleet_Drivers_The_driver_haLf": "该司机因欠费被平台管控，无法绑定",
  "Fleet_NewPaymentFlow__sXzn": "编辑费用",
  "Fleet_copy_No_vehicle_KXvt": "暂未绑定任何车辆",
  "Fleet_Resdesign_Balance_GHxU": "账户",
  "Fleet_perception__mEjw": "车队收入组成",
  "Fleet_Drivers_At_the_IfBL": "开始日期",
  "Fleet_control_You_can_UzFy": "在你支付完近期欠款之前，你无法下架车辆。",
  "Fleet_control_Repayment_records_uMeU": "还款记录",
  "Fleet_Drivers_Confirmation_wvYD": "确认",
  "Fleet_Mgt_Please_select_zmgM": "请至少选择一项",
  "Fleet_NewPaymentFlow__tgtT": "租金",
  "Fleet_copy_Vehicles_dwty": "车辆",
  "Fleet_check_CBpH_TcGJ": "尽量使用单一背景色，例如白色",
  "Fleet_issue_wggA_MxPE": "总净收入（税后）",
  "Fleet_issue_aIsE_dmqL": "所有司机",
  "Fleet_Drivers_Go_Bind_TxwZ": "去绑定",
  "Fleet_start_vHHF_ayCO": "账号安全",
  "Fleet_Drivers_Go_Settings_vpjg": "去设置",
  "Fleet_NewPaymentFlow__WiKw": "详情",
  "Fleet_Drivers_Settings_zKsG": "已设置",
  "Fleet_check_uiYb_OxPW": "由于你的头像未通过审核次数已达到{{reject_max_time}}次，你暂时无法使用该功能，请重新上传正确头像，通过审核后可恢复正常使用。",
  "Fleet_check_kLTg_CIuk": "拍照",
  "Fleet_NewPaymentFlow__gTTE": "线上已收",
  "Fleet_Resdesign_Error_OWDd": "邮件输入格式错误",
  "Fleet_Drivers_Please_complete_CZYg": "请先填写完该规则的所有项",
  "Fleet_check_hceA_ycnc": "知道了",
  "Fleet_NewPaymentFlow__qbqz": "总已收金额",
  "Fleet_NewPaymentFlow__GUTP": "一次性费用",
  "Fleet_2_To_be_Egnx": "待绑定",
  "Fleet_tittle_The_maximum_tjjA": "可选的最大时间跨度为{{max_time_span}}天",
  "Fleet_Resdesign_All_XnPT": "全部",
  "Fleet_check_OQKj_GHLS": "头像审核通过后，你才可以给司机绑定车辆。",
  "Fleet_check_fBNK_CTjZ": "头像审核通过后，你才可以邀请司机。",
  "Fleet_issue_sumF_oFSJ": "产生的税费",
  "Fleet_start__VNTW": "你还没有添加车辆，点击+号添加",
  "Fleet_Drivers_Please_set_HvnQ": "请设置分账规则",
  "Fleet_start_pHZA_kozl": "是否确认退出？",
  "Fleet_optimizaton__GwKg": "在你通过证件审核后，你才能进入司机市场以及绑定司机",
  "Fleet_Resdesign_Cash_XfVb": "现金",
  "Fleet_Phase2_Invitation_accepted_jUWV": "已接受邀请",
  "Fleet_Drivers_Verification_code_EAbp": "验证码已经发送给{{phone_number}}",
  "Fleet_copy_Add_a_QOUx": "添加文件",
  "Fleet_Resdesign_November_kXkU": "十一月",
  "Fleet_NewPaymentFlow__sJZs": "加入车队邀请",
  "Fleet_NewPaymentFlow__JGoj": "费用收取方式",
  "Fleet_control_The_total_Mche": "你的欠款已被免除，余额会被重新计算。如果之后你的欠款金额过高，车队所有司机将受到管控，无法接收现金单，直到欠款被还清。",
  "Fleet_Resdesign_Income_summary_PZsP": "收入概要",
  "Fleet_NewPaymentFlow__Wzlo": "设置租金等费用",
  "Fleet_0303_Fleet_WorkRegime_Weekly_collection_PFfF": "每周一00:00-12:00之间进行收取",
  "upt-city---tips": "修改次数超限，不能再修改",
  "Fleet_perception__SzYM": "车队表现",
  "Fleet_Mgt_Question_feedback_uwFO": "问题反馈",
  "Fleet_check_wRSz_suag": "同意",
  "Fleet_NewPaymentFlow_lHPn_FNIg": "请输入你要收取的费用项名称",
  "Fleet_Resdesign_Saturday_mzeO": "周六",
  "Fleet_FleetRecommendation_Successfully_saved_wLuW": "保存成功",
  "Fleet_NewPaymentFlow_ecXd_ctUR": "费用类型",
  "Fleet_start__EurG": "你还没有绑定司机，点击按钮邀请或寻找司机吧",
  "Fleet_Resdesign_Confirmation_McBF": "确认",
  "Fleet_Resdesign_Total_lDoG": "收到现金总额",
  "Fleet_Mgt_No_information_DDuc": "暂无信息",
  "Fleet_Drivers_Add_slkd": "添加",
  "Fleet_Drivers_The_driver_AvoC": "该司机的证件已全部通过审核。",
  "Fleet_Drivers_Confirmation_jXFy": "确认",
  "Fleet_NewPaymentFlow__Qbnn": "在选择的时间段内，未收到的所有生效费用项的总金额",
  "Fleet_NewPaymentFlow__pMHK": "账单列表",
  "Fleet_control_Please_check_tIFA": "请在解绑前与司机核对账单，避免司机欠费。你确认要解绑该司机吗？",
  "Fleet_start__OCpm": "保存成功",
  "Fleet_NewPaymentFlow__GwuJ": "备注",
  "Fleet_NewPaymentFlow_BBWr_ImCE": "当前车辆存在未结清的费用，请前往司机管理功能，先为司机解绑该车辆，再尝试删除该车辆",
  "Fleet_Tool_Unable_to_jqFL": "解绑失败，请稍后再试",
  "Fleet_Resdesign_Select_End_qdXu": "选择结束时间",
  "Fleet_Drivers_Next_step_PxoK": "下一步",
  "Fleet_copy_Change_UEsW": "修改",
  "Fleet_NewPaymentFlow__xiMh": "线下收款",
  "Fleet_NewPaymentFlow_TMhC_InJP": "确认删除车辆？",
  "Fleet_deactivation_DenK_QPgy": "上架新车辆",
  "Fleet_Mgt_Send_a_orZR": "发送报表",
  "Fleet_NewPaymentFlow__GCoA": "生效日期",
  "Fleet_start__kQXw": "开启“新手指引”入口",
  "Fleet_NewPaymentFlow__EnGk": "扣款时间",
  "Fleet_Drivers_The_driver_wclR": "该司机已绑定其他车头",
  "Fleet_start__MHFQ": "添加银行卡账号",
  "Fleet_Mgt_Driver_performance_pmda": "司机表现",
  "Fleet_deactivation_AxQl_axxa": "由于你长时间未回复司机的消息，对应车辆已被下架。",
  "Fleet_Tool_Confirmation_of_xfhT": "确认解绑",
  "upt-city---index_city_title": "注册城市",
  "Fleet_Mgt_Select_date_INmY": "选择日期",
  "Fleet_MultiUserLogin_Add_succeed_kBCi": "添加成功",
  "Fleet_perception__LHEy": "（我）",
  "Fleet_NewPaymentFlow__ZQOF": "下一步",
  "Fleet_Drivers_The_invitation_ytYi": "邀请链接已成功发送，等待司机接受邀请。",
  "Fleet_Drivers_Please_help_ZYii": "请帮助该司机注册账号完成绑定。",
  "Fleet_NewPaymentFlow__AMrP": "你需要和司机线下收取租金等费用",
  "Fleet_issue_PMnB_Wfat": "金额（税前）",
  "Fleet_start__SeMT": "邀请你认识的司机加入车队，或到市场上联系其他有租车需求的司机",
  "Fleet_Resdesign_Data_loading_pcxE": "数据加载中",
  "Fleet_NewPaymentFlow__VoUq": "费用停用后，从下一期开始将不会收到后续款项",
  "Fleet_check_dPXn_jSAI": "隐私条款",
  "Fleet_Resdesign_April_Qtaf": "四月",
  "Fleet_0303_Fleet_WorkRegime_Monthly_uzwN": "每月",
  "Fleet_optimizaton__AfWb": "查看审核进度",
  "Fleet_Mgt_Vehicle_Details_ihSv": "车辆详情",
  "upt-city---header": "每6个月可更换注册城市({data.change_time})次",
  "Fleet_Mgt_Pull_down_YzpV": "下拉可以刷新",
  "Fleet_NewPaymentFlow__TkSG": "联系车头",
  "Fleet_Drivers_Start_date_GZYy": "开始日期不能为空",
  "Fleet_Resdesign_Tuesday_UAxw": "周二",
  "Fleet_Drivers_Frequency_mzAO": "频率",
  "Fleet_perception__iBGo": "司机表现",
  "Fleet_NewPaymentFlow_sKlJ_uHRX": "费用项{{num}}",
  "Fleet_NewPaymentFlow__PsNL": "总应收金额",
  "Fleet_NewPaymentFlow_ayYQ_vGUU": "司机手机号",
  "Fleet_Tool_Front_Recommended_giVU": "车头推荐列表",
  "Fleet_Resdesign_Start_end_Nnvy": "开始/结束",
  "Fleet_Tool_Want_to_aUcS": "想加入其他车队？",
  "Fleet_NewPaymentFlow__aQyj": "添加其它费用",
  "balance_v1---withdraw": "提现",
  "Fleet_Wording_Balance_YWuq": "余额",
  "Fleet_Resdesign_Total_income_hyAh": "总净收入",
  "Fleet_Resdesign_Withdrawal_records_KMxk": "提现记录",
  "Fleet_NewPaymentFlow__oKdN": "添加线下收款记录",
  "Fleet_control_FAQ_djfs": "FAQ",
  "Fleet_check_pajT_vPwq": "请上传头像",
  "Fleet_Tool_If_you_dYhg": "如需再次发起解绑，请联系客服",
  "Fleet_rental_Week_wLOx": "周",
  "Fleet_Drivers_Enter_the_fNet": "请输入你会以以下频率从司机处得到的金额",
  "Fleet_control_Withdrawal_and_dAGM": "提现与还款记录",
  "Fleet_Drivers_The_driver_FaYT": "该司机的工作规则已经保存。请帮助该司机注册账号完成绑定",
  "Fleet_Tool_You_have_Trbx": "你已成功和车头解绑，请联系车头讨论车辆归还细节",
  "Fleet_NewPaymentFlow__upZL": "费用类型",
  "Fleet_Mgt__Express_dSGM": "{{Express}}",
  "Fleet_NewPaymentFlow__ELan": "生效时间",
  "Fleet_NewPaymentFlow__cQQc": "未收金额",
  "Fleet_start__JhMH": "关闭后，你将不会在首页看到“新手指引”入口",
  "Fleet_Resdesign_December_uJlY": "十二月",
  "Fleet_NewPaymentFlow__nJcc": "全部司机",
  "Fleet_start__ikUr": "上架你的车辆，展示给更多需要租车的司机",
  "Fleet_NewPaymentFlow_mTod_iDbL": "应收金额",
  "Fleet_Drivers_Separation_rules_eXvM": "分账规则",
  "Fleet_start_UcCd_UVKp": "{{app_name}}撮合工具",
  "Fleet_copy_Remove_vehicle_DDrG": "解绑车辆",
  "Fleet_NewPaymentFlow__GiSP": "费用生效时间",
  "Fleet_Drivers_Select_a_yuVt": "请选择开始日期",
  "Fleet_Resdesign_July_Zroi": "七月",
  "Fleet_NewPaymentFlow__vurJ": "自动收取：租金及其它费用将会自动从你的司机钱包中扣除，不足的部分你需要线下支付给车头",
  "Fleet_Resdesign_August_mcie": "八月",
  "Fleet_issue_WMHZ_ZyWR": "总净收入（税前）",
  "Fleet_start__xLsd": "去上架",
  "Fleet_Resdesign__Biaz": "三月",
  "Fleet_NewPaymentFlow__wclB": "请仔细阅读租金等相关费用信息，确认无误后点击接受，即可加入车队",
  "Fleet_NewPaymentFlow__XoLO": "在选择的时间段内的所有生效的费用项的总金额",
  "Fleet_Resdesign_Enter_the_ejUB": "请输入你想用于接收csv收入报表的邮箱",
  "Fleet_Drivers_Enter_a_HciF": "请输入有效的电话号码",
  "Fleet_NewPaymentFlow__ydGV": "租赁信息",
  "Fleet_control_pbwt_loki": "暂不加入",
  "Fleet_deactivation_xUfQ_GyUZ": "你有车辆已被下架",
  "Fleet_perception__oMHQ": "前往",
  "Fleet_DriverUnbindFleet_Bind_afzf": "绑定中",
  "Fleet_Drivers_Enter_the_Iqvb": "请输入司机手机号码",
  "Fleet_Resdesign_Income_flow_fcPZ": "收入明细",
  "Fleet_check_tint_NtpW": "审核结果将会在<span>24-48小时</span>内以短信和邮件的形式通知你，请及时关注。",
  "Fleet_Drivers_There_are_mefN": "存在尚未填写完的规则，立即保存不会保留未填写完的规则",
  "Fleet_perception__TFIy": "收入明细",
  "Fleet_Drivers_Confirm_deletion_XNBw": "确认删除规则{{number}}？",
  "Fleet_control_GyDm_gKOe": "联系车头",
  "Fleet_Mgt_Editing_documents_khkk": "编辑证件",
  "Fleet_Resdesign_Total_income_XZbI": "总收入",
  "Fleet_NewPaymentFlow_xaDm_BLCM": "当前车辆还存在未支付的费用{{Price}}，请结清费用后再解绑。如果你已收到该费用，可以直接将未结清的费用调整为0",
  "Fleet_Drivers_The_amount_WtWG": "金额不能为空",
  "Fleet_NewPaymentFlow__znZG": "当前司机还存在未支付的费用{{Price}}，请结清费用后再解绑。如果你已收到该费用，可以直接将未结清的费用调整为0",
  "Fleet_control2_Are_you_Pujl": "确定解绑司机？",
  "Fleet_Resdesign_Sent_successfully_wwMu": "发送成功",
  "Fleet_copy_Vehicle_list_PmvG": "车辆列表为空",
  "Fleet_Resdesign_Page_Name_OKXD": "开始",
  "Fleet_check_Admw_cABo": "暂不同意",
  "Fleet_Resdesign_Clear_uVXL": "清除",
  "Fleet_check_XDUC_GDrR": "正确示例",
  "Fleet_Tool_Cancel_axjb": "取消",
  "Fleet_NewPaymentFlow__Khbs": "自动收取",
  "Fleet_start__eaYV": "你可以随时在“个人中心”-“设置”中再次打开",
  "Fleet_Tool_Confirmation_vzhv": "确认",
  "Fleet_NewPaymentFlow__DRkc": "停用费用",
  "Fleet_Drivers_Content_may_ZBiI": "内容可能丢失",
  "Fleet_check_LJzu_FVZT": "不是全脸",
  "Fleet_Resdesign_Cash_LiLC": "现金",
  "Fleet_Phase1_Go_vwbQ": "前往",
  "Fleet_start__rZdn": "新手指引",
  "Fleet_NewPaymentFlow__VKFl": "暂不加入",
  "Fleet_NewPaymentFlow__MfyW": "{{Fleet_name}}邀请你加入车队",
  "Fleet_Resdesign_Slide_more_YbCQ": "上滑加载更多",
  "Fleet_Resdesign_Start_SDWR": "开始",
  "Fleet_Resdesign_September_MGfs": "九月",
  "Fleet_NewPaymentFlow__owTK": "选择为该司机绑定的车辆",
  "Fleet_Resdesign_February_XtXo": "二月",
  "Fleet_start__AAdW": "邀请司机",
  "Fleet_NewPaymentFlow__yYUL": "确认解绑司机？",
  "Fleet_Drivers_Return_Driver_SuUV": "返回司机列表",
  "Fleet_NewPaymentFlow__CFxF": "司机账单详情",
  "Fleet_NewPaymentFlow_FMtz_Fgwk": "修改为线下收取？",
  "Fleet_NewPaymentFlow_MOPD_sBcZ": "已收金额",
  "Fleet_check_bHXh_cGKL": "你的头像已审核通过，无需重新上传",
  "Fleet_check_XKad_fPlI": "请重新上传头像",
  "Fleet_NewPaymentFlow__Hecx": "暂不绑定车辆",
  "Fleet_Resdesign_Friday_GxZE": "周五",
  "Fleet_start__ndBl": "关闭“新手指引”",
  "Fleet_NewPaymentFlow__IqzA": "司机账单列表",
  "GDriver_model__chvL": "充值",
  "Fleet_NewPaymentFlow__ifcR": "停用时间",
  "Fleet_NewPaymentFlow_GZpD_WRgn": "修改为自动收取？",
  "Fleet_NewPaymentFlow__BevI": "每周",
  "Fleet_Drivers_Name_nwDP": "名称",
  "Fleet_Resdesign_Not_selected_xuLq": "未选择",
  "Fleet_check_iuvA_xbpz": "点击上传头像",
  "Fleet_Mgt_My_driver_nueB": "我的司机",
  "Fleet_Resdesign_Saved_Rbay": "已保存",
  "Fleet_perception__akHT": "你有历史坏账未还清，为不影响你的收入提现，请及时还款，点此查看详情。",
  "Fleet_Resdesign_Data_loading_WbGr": "数据加载完成",
  "Fleet_issue_nMWy_QVYj": "金额（税后）",
  "Fleet_NewPaymentFlow_iJcz_jiCd": "邀请中",
  "upt-city---submit": "修改注册城市",
  "Fleet_start__tmar": "返回",
  "Fleet_copy_My_pzKZ": "我的",
  "Fleet_NewPaymentFlow__eItp": "已收齐",
  "Fleet_NewPaymentFlow_BoPa_SvIW": "线上收款",
  "Fleet_NewPaymentFlow__BVvn": "线下收取",
  "Fleet_check_fHaJ_tEra": "展示你的全脸和肩膀",
  "Fleet_check_mDSh_CVHS": "请确保你的照片符合以下要求",
  "Fleet_NewPaymentFlow__Mhyi": "删除",
  "Fleet_Resdesign_Total_unit_iLuD": "总单量",
  "unbindTips": "确定要删除该车辆吗？司机将不能使用该车辆。",
  "unbindSuccessTips": "成功解除绑定",
  "my_wallet": "我的钱包",
  "bindSuccessTips": "链接成功",
  "bindTips": "确定要将车辆与司机绑定？",
  "dinfo---bank": "Bank Account"
}